/**
 * Deterministic-ish id generator for the BETA mock backend.
 *
 * The mock store is purely in-memory and resets on logout, so we don't need
 * crypto-grade randomness — a monotonic counter prefixed with a tag does
 * the job and produces stable ids for the lifetime of the session.
 */
let counter = 1_000_000;
export function newId(prefix = "id") {
  counter += 1;
  return `${prefix}_${counter.toString(36)}`;
}

/** Reset the counter — called when the store is reset. */
export function resetIdCounter() {
  counter = 1_000_000;
}

/** Current ISO timestamp — wrapped so the mock can be deterministic later. */
export function nowIso() {
  return new Date().toISOString();
}

/** Today as YYYY-MM-DD. */
export function todayYmd() {
  return new Date().toISOString().slice(0, 10);
}

/** Add `days` to today and return YYYY-MM-DD. Negative for past dates. */
export function dateOffsetYmd(days) {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
}

/** Subtract `hours` from now and return an ISO timestamp. */
export function hoursAgoIso(h) {
  const d = new Date();
  d.setHours(d.getHours() - h);
  return d.toISOString();
}
